import * as angular from "angular";
import {IController} from "angular";
import {AccountRequests} from "../../services/account-requests.service";
import {AccountsAlerts} from "../../services/accounts-alerts.service";
import {AccountModel} from "../../angular/models/account.model";
import {SupplyAccountType} from "../../types/supply-account.type";
import {$accountFactory} from "../../$account.factory";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import * as _ from "lodash";
import {AccountsFacadeService} from "../../angular/services/accounts-facade.service";

export class DriverAccountPreferencesCtrl implements IController {

  account: AccountModel;
  preferences: any;

  private preferencesCopy: any;
  private accountCopy: AccountModel;
  private accountRef: any;

  public supplyAccountTypes: typeof SupplyAccountType = SupplyAccountType;
  public isSaveAvailable: boolean = false;
  public loading: boolean = false;

  constructor(private $account: $accountFactory,
              private accountRequests: AccountRequests,
              private accountsAlerts: AccountsAlerts,
              private accountsFacadeService: AccountsFacadeService,
              private $timeout,
              private commonsAlertsService: CommonsAlertsService, private $log, private triBreadcrumbsService) {
  }

  $onInit() {
    this.preferencesCopy = angular.copy(this.preferences);
    this.accountRef = this.$account(this.account.id);
    this.accountCopy = angular.copy(this.account);
  }

  onActiveChange() {
    this.isSaveAvailable = !_.isEqual(this.accountCopy, this.account);
  }

  onSaveChanges() {
    this.isSaveAvailable = false;
    // this.loading = true;

    this.accountsFacadeService.editOne(this.account.id, this.account);
    // this.accountRef.$update(this.account).then(
    //   (updatedAccount: AccountModel) => {
    //     this.accountCopy = updatedAccount;
    //     this.commonsAlertsService.preferencesSuccess();
    //   },
    //   (error) => {
    //     this.commonsAlertsService.preferencesError();
    //     this.$log.error('Fail to change account Status @driverAccountPreferences@onActiveChange', error)
    //   }
    // ).finally(() => {
    //   this.loading = false;
    // })
  }

  onCancelChanges(){
    this.account = angular.copy(this.accountCopy);
    this.onActiveChange();
  }
}

angular
  .module('bringoz.admin.accounts')
  .component('driverAccountPreferences', {
    bindings: {
      account: '<',
      preferences: '<'
    },
    template: require('./driver-account-preferences.html').default,
    controller: DriverAccountPreferencesCtrl
  });
